import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { firstValueFrom, forkJoin } from 'rxjs';
import { DataSourceService } from './services/data-source.service';
import { DashboardService } from './services/dashboard.service';

// Returns a Promise (not the Observable) on purpose: a Promise cannot be unsubscribed,
// so a superseded/cancelled navigation can no longer abort the in-flight requests
// mid-stream (which surfaced as net::ERR_INCOMPLETE_CHUNKED_ENCODING under withFetch).
// This mirrors the previous, always-working Promise-based data source resolver.
export const layoutResolver: ResolveFn<unknown> = () => {
  return firstValueFrom(
    forkJoin([
      inject(DataSourceService).loadDataSources(),
      inject(DashboardService).loadAllDashboards(),
    ]),
  );
};
